<script>
    import { onMount } from "svelte";
    import { Editor } from "@tiptap/core";
    import StarterKit from "@tiptap/starter-kit";

    let { value = $bindable("") } = $props();

    let editor = $state();
    let editorElement = $state();

    function run(command) {
        if (!editor) return;
        command(editor.chain().focus()).run();
    }

    function isActive(type) {
        return editor ? editor.isActive(type) : false;
    }

    onMount(() => {
        editor = new Editor({
            element: editorElement,
            extensions: [StarterKit],
            content: value || "<p></p>",
            onUpdate: ({ editor: current }) => {
                value = current.getHTML();
            },
        });

        return () => {
            editor?.destroy?.();
        };
    });
</script>

<div class="rte">
    <div class="rte-toolbar">
        <button
            type="button"
            title="Bold"
            class:active={isActive("bold")}
            onclick={() => run((c) => c.toggleBold())}>B</button
        >
        <button
            type="button"
            title="Italic"
            class:active={isActive("italic")}
            onclick={() => run((c) => c.toggleItalic())}>I</button
        >
        <button
            type="button"
            title="Bulleted List"
            class:active={isActive("bulletList")}
            onclick={() => run((c) => c.toggleBulletList())}>•</button
        >
        <button
            type="button"
            title="Numbered List"
            class:active={isActive("orderedList")}
            onclick={() => run((c) => c.toggleOrderedList())}>1.</button
        >
        <button
            type="button"
            title="Quote"
            class:active={isActive("blockquote")}
            onclick={() => run((c) => c.toggleBlockquote())}>"</button
        >
        <button type="button" title="Undo" onclick={() => run((c) => c.undo())}
            >⟲</button
        >
        <button type="button" title="Redo" onclick={() => run((c) => c.redo())}
            >⟳</button
        >
    </div>

    <div class="rte-editor" bind:this={editorElement}></div>
</div>
